// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--pMNt3","label":"styles-module--label--12CjW","total":"styles-module--total--2K_4Z","buy":"styles-module--buy--2ftBb"};